import styled from "styled-components";
import { getDeviceType, getTheme, logger, themed, FlexStream, FloatedImage, Flow, Stream, Text as Tx, Tooltip, } from "@bracket/ui";
import { PanelItem, } from "@bracket/platform/components";
import { formatDollars, formatWEI, } from "@formatters";
import { MobileSummaryItem, } from "./MobileSummaryItem";

import type { Asset, } from "@bracket/types";
import type { ReactNode, } from "react";





export declare type SummaryItemProps = {
	label: string;
	value: { usd: number; brkt?: string; perc?: number; };
	denomination?: Asset;
	tip?: string;
	showDollars?: boolean;
	showAsset?: boolean;
	showPercent?: boolean;
	showPercentOnly?: boolean;
	logo?: string;
	x?: boolean;
	noPercent?: boolean;
}




export const SummaryItem = ( props: SummaryItemProps ) => {
	themed();

	const {
		label,
		value,
		denomination,
		tip,
		showAsset = true,
		showDollars = true,
		showPercent = true,
		showPercentOnly = false,
		logo,
		x = false,
		noPercent = false,
	} = props;

	if(getDeviceType() === "MOBILE") {
		return <MobileSummaryItem {...props} />;
	}

	if(label === "Health Factor" && typeof value.perc === "number" && value.perc > 100) {
		return null;
	}

	const symbol = denomination?.symbol, decimals = denomination?.decimals, denominationLabel = denomination?.label;

	if(showPercentOnly) {
		return (
			<PanelItem label={label} tip={tip} logo={logo} color="surface_variant_on" mobileLogoCenter mobileLabelLeftPad="0.5rem">
				<Tx h6>{ typeof value.perc === "number" && (<span className="percent">{ x ? "" : value.perc > 0 ? "+" : "" }{ value.perc.toFixed(2) }{ x ? "x" : noPercent ? "" : "%" }</span>) }</Tx>
			</PanelItem>
		);
	}

	return (
		<PanelItem label={label} tip={tip} logo={logo} color="surface_variant_on" mobileLogoCenter mobileLabelLeftPad="0.5rem">
		{
			symbol === "USDC" ? (
				<ValueGroup>
					<Tx h6>
						{ showDollars && formatDollars(value.usd) }
						{ showPercent && typeof value.perc === "number" && !isNaN(value.perc) && (<span className="percent">{ x ? "" : value.perc > 0 ? "+" : "" }{ value.perc.toFixed(2) }{ x ? "x" : noPercent ? "" : "%" }</span>) }
					</Tx>
				</ValueGroup>
			) : (
				<ValueGroup>
					<Tx h6>
						{ showDollars && formatDollars(value.usd) }
						{ showPercent && typeof value.perc === "number" && !isNaN(value.perc) && (<span className="percent">{ x ? "" : value.perc > 0 ? "+" : "" }{ value.perc.toFixed(2) }{ x ? "x" : noPercent ? "" : "%" }</span>) }
					</Tx>
					{/* {
						showAsset && denomination && value.brkt && (
							<Tx color="surface_on" className="brkt-value">
								{formatWEI(value.brkt, decimals, symbol === "USDC" ? 2 : 5)} {denominationLabel}
							</Tx>
						)
					} */}
				</ValueGroup>
			)
		}
		</PanelItem>
	)

}

const ValueGroup = styled(Flow)`
	span {
		&.percent {
			padding-left: 1rem;
			color: ${() => getTheme().subheading};
			font-size: 1rem;
			/* Mobile: place percent on a new line below the value */
			@media (max-width: 768px) {
				display: block;
				padding-left: 0;
				margin-top: .25rem;
				text-align: right;
			}
		}
	}
	> p {
		padding-top: .25rem;
		&.brkt-value {
			padding-top: 0;
		}
		&.perc-value {
			position: absolute;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 1.5rem;
			right: 1rem;
		}
	}
`;
